import { z } from "zod";

const chatMessageRoleSchema = z.enum(["user", "assistant", "system", "tool"]);

const toolResultSchema = z.discriminatedUnion("toolName", [
  z.object({
    type: z.literal("tool-result"),
    toolCallId: z.string(),
    toolName: z.literal("codeChangeTool"),
    result: z.object({
      success: z.boolean(),
      appliedDiffs: z.array(z.string()),
      fileVersionId: z.string().optional(),
      fileVersionSummary: z.string().optional(),
    }),
  }),
]);

export const chatMessageContentSchema = z
  .discriminatedUnion("type", [
    z.object({
      type: z.literal("string"),
      content: z.string(),
    }),
    z.object({
      type: z.literal("array"),
      content: z.array(
        z.discriminatedUnion("type", [
          z.object({
            type: z.literal("text"),
            text: z.string(),
            // NOTE (Bobby: 2025-06-25): It is default text if not provided. This specifies the content inside the text field
            // and alternative content types like products can be parsed into a object like ChatProductItem
            contentType: z
              .enum(["text", "product", "buildError", "revert"])
              .optional(),
            isHidden: z.boolean().optional(),
          }),
          z.object({
            type: z.literal("tool-call"),
            toolCallId: z.string(),
            toolName: z.string(),
            args: z.any(),
          }),
          ...toolResultSchema.options,
          z.object({
            type: z.literal("image"),
            id: z.string().optional(),
            image: z.string(),
            isHidden: z.boolean().optional(),
          }),
        ]),
      ),
    }),
  ])
  .describe("ChatMessageContent");

export const chatMessageSchema = z
  .object({
    id: z.string().uuid(),
    createdAt: z.coerce.date(),
    role: chatMessageRoleSchema,
    content: chatMessageContentSchema,
    chatId: z.string().uuid(),
  })
  .describe("ChatMessage");

export const contextItemSchema = z
  .discriminatedUnion("type", [
    z.object({
      type: z.literal("selectedProduct"),
      product: z.object({
        externalId: z.string(),
      }),
    }),
    z.object({
      type: z.literal("assetUrl"),
      url: z.string(),
    }),
    z.object({
      type: z.literal("openPage"),
      pageId: z.string(),
    }),
  ])
  .describe("ContextItem");

export const chatProductItemSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    description: z.string(),
    image: z.string().nullable(),
  })
  .describe("ChatProductItem");

export const chatBuildErrorItemSchema = z
  .object({
    type: z.literal("buildError"),
    isReverting: z.boolean(),
  })
  .describe("ChatBuildErrorItem");

export const chatAssetItemSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    fileExtension: z.string(),
  })
  .describe("ChatAssetItem");
